<template>
  <div class="a-cover">
    <Transition name="fade">
      <Header class="z-20" :inert="showUnibuddy" />
    </Transition>

    <Transition name="fade">
      <RouterView
        name="campus"
        :inert="!isCampus || showUnibuddy || isMedia"
        :aria-hidden="!isCampus || showUnibuddy || isMedia"
      />
    </Transition>

    <Transition name="fade">
      <RouterView
        name="content"
        :inert="showUnibuddy"
        :aria-hidden="showUnibuddy"
      />
    </Transition>

    <Transition name="fade">
      <Unibuddy v-if="showUnibuddy" />
    </Transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { loadKrp } from '@/mixins'
import Header from '@/components/Header.vue'
const Unibuddy = () => import('@/components/Unibuddy.vue')

export default {
  name: 'Viewer',

  components: {
    Header,
    Unibuddy
  },

  mixins: [loadKrp],

  computed: {
    ...mapState(['touch', 'mobile', 'showUnibuddy', 'isCampus', 'isMedia']),
    ...mapGetters([])
  },

  created() {
    if (this.mobile) {
      this.$store.commit('toggleSidebarState', false)
      this.$store.commit('toggleCategoriesState', false)
    }
  }
}
</script>
